import { render, staticRenderFns } from "./RegistrationRequestMarkTestOnlyButton.vue?vue&type=template&id=5c854da9"
import script from "./RegistrationRequestMarkTestOnlyButton.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestMarkTestOnlyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports